import apiApp from "./index";
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const ComponentsApi = {
  // Create Components Api

  CreateComponents: (data) => {
    const token = localStorage.getItem("UserjwtToken");

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .post(`/components`, data, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // List Components Api
  ListComponents: (page, limit) => {
    const token = localStorage.getItem("UserjwtToken");
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/components?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
};

export default ComponentsApi;
